export default {
    "color": [
        "#7dc058",
        "#169898",
        "#3A36DB",
        "#F3654A",
        "#0090FF",
        "#1AD598"
    ],
    "backgroundColor": "rgba(0,0,0,0)",
    "textStyle": {},
    "title": {
        "textStyle": {
            "color": "#000"
        },
        "subtextStyle": {
            "color": "#999999"
        }
    },
    "line": {
        "itemStyle": {
            "borderWidth": "2"
        },
        "lineStyle": {
            "width": "4",
            "type": "solid"
        },
        "symbolSize": "7",
        "symbol": "circle",
        "smooth": true
    },
    "radar": {
        "itemStyle": {
            "borderWidth": "2"
        },
        "lineStyle": {
            "width": "4",
            "type": "solid"
        },
        "symbolSize": "7",
        "symbol": "circle",
        "smooth": true
    },
    "bar": {
        "itemStyle": {
            "barBorderWidth": "1",
            "barBorderColor": "#ccc"
        }
    },
    "pie": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "scatter": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "boxplot": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "parallel": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "sankey": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "funnel": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "gauge": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        }
    },
    "candlestick": {
        "itemStyle": {
            "color": "#e098c7",
            "color0": "transparent",
            "borderColor": "#e098c7",
            "borderColor0": "#8fd3e8",
            "borderWidth": "2"
        }
    },
    "graph": {
        "itemStyle": {
            "borderWidth": "1",
            "borderColor": "#ccc"
        },
        "lineStyle": {
            "width": 1,
            "color": "#aaa"
        },
        "symbolSize": "7",
        "symbol": "circle",
        "smooth": true,
        "color": [
            "#7dc058",
            "#081d99",
            "#075891",
            "#71669e",
            "#cc70af",
            "#7cb4cc"
        ],
        "label": {
            "color": "#000"
        }
    },
    "map": {
        "itemStyle": {
            "areaColor": "#eee",
            "borderColor": "#444",
            "borderWidth": 0.5
        },
        "label": {
            "color": "#000"
        },
        "emphasis": {
            "itemStyle": {
                "areaColor": "#e098c7",
                "borderColor": "#444",
                "borderWidth": 1
            },
            "label": {
                "color": "#000"
            }
        }
    },
    "geo": {
        "itemStyle": {
            "areaColor": "#eee",
            "borderColor": "#444",
            "borderWidth": 0.5
        },
        "label": {
            "color": "#000"
        },
        "emphasis": {
            "itemStyle": {
                "areaColor": "#e098c7",
                "borderColor": "#444",
                "borderWidth": 1
            },
            "label": {
                "color": "#000"
            }
        }
    },
    "categoryAxis": {

        "axisLine": {

            "show": true,
            "lineStyle": {
                "color": "#999999",
                opacity: 0.3
            }

        },

        "axisTick": {

            "show": true,
            alignWithLabel: true,  // 确保刻度线与刻度标签对齐

            "lineStyle": {
                "color": "#999999",
                opacity: 1
            }
        },
        "axisLabel": {
            margin: 15,  // 设置 X 轴标签距离轴线的距离为 20px

            "show": true,
            "color": "#000"
        },
        "splitLine": {
            "show": false,
            "lineStyle": {
                "color": ["#999999"],
                "opacity": 1// 网格线颜色透明度
            }
        },
    },
    "valueAxis": {
        "axisLine": {
            "show": false,
            "lineStyle": {
                "color": "#999999",
            }
        },
        "axisTick": {
            "show": false,
            "lineStyle": {
                "color": "#999999"
            }
        },
        "axisLabel": {
            "show": true,
            "color": "#000",
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": ["#999999"],
                "type": "dashed",
                width: 1,            // 网格线宽度
                "opacity": 0.8// 网格线颜色透明度
            }
        }
    },
    "logAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "#999999"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "#999999"
            }
        },
        "axisLabel": {
            "show": true,
            "color": "#000"
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": ["#999999"],
                "type": "dashed",
                "opacity": 0.6 // 网格线颜色透明度
            }
        },
        "splitArea": {
            "show": true,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "timeAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "#999999"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "#999999"
            }
        },
        "axisLabel": {
            "show": true,
            "color": "#000"
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": ["#999999"],
                "type": "dashed",
                "opacity": 0.6 // 网格线颜色透明度
            }
        },
        "splitArea": {
            "show": true,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "toolbox": {
        "iconStyle": {
            "borderColor": "#999"
        },
        "emphasis": {
            "iconStyle": {
                "borderColor": "#666"
            }
        }
    },
    "legend": {
        itemGap: 40,
        "textStyle": {
            "color": "#000",
            "fontSize": 12,
        },
        icon: "roundRect",
        itemHeight: 12,
        "orient": "horizontal",
        "bottom": 0,
        "center": "50%"
    },
    "tooltip": {
        "axisPointer": {
            "lineStyle": {
                "color": "#ccc",
                "width": 1
            },
            "crossStyle": {
                "color": "#ccc",
                "width": 1
            }
        },
        "backgroundColor": "#fff",
        "borderColor": "rgba(0, 0, 0, 0)",
        "borderWidth": 0,
        "textStyle": {
            "color": "#000"
        },
        "padding": [5, 10],
        "extraCssText": "box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);"
    },
    "timeline": {
        "lineStyle": {
            "color": "#8fd3e8",
            "width": 1
        },
        "itemStyle": {
            "color": "#8fd3e8",
            "borderWidth": 1
        },
        "controlStyle": {
            "color": "#8fd3e8",
            "borderColor": "#8fd3e8",
            "borderWidth": 1
        },
        "checkpointStyle": {
            "color": "#8fd3e8",
            "borderColor": "#8fd3e8"
        },
        "label": {
            "color": "#8fd3e8"
        },
        "emphasis": {
            "itemStyle": {
                "color": "#8fd3e8"
            },
            "controlStyle": {
                "color": "#8fd3e8",
                "borderColor": "#8fd3e8"
            },
            "label": {
                "color": "#8fd3e8"
            }
        }
    },
    "visualMap": {
        "color": [
            "#c23531",
            "#2f4554",
            "#61a0a8",
            "#d48265",
            "#91c7ae",
            "#749f83",
            "#ca8622",
            "#bda29a",
            "#6e7074",
            "#546570",
            "#c4e3cb"
        ]
    },
    "dataZoom": {
        "backgroundColor": "rgba(0,0,0,0.5)",
        "dataBackgroundColor": "rgba(255,255,255,0.5)",
        "fillerColor": "rgba(182,162,222,0.2)",
        "handleColor": "#a2a2a2",
        "handleSize": "8",
        "textStyle": {
            "color": "#000"
        }
    },
    "markPoint": {
        "label": {
            "color": "#000"
        }
    },
    "markLine": {
        "lineStyle": {
            "color": "#999",
            "width": 2,
            "type": "solid"
        }
    },
    "markArea": {
        "itemStyle": {
            "color": "rgba(255,255,255,0.1)"
        },
        "label": {
            "color": "#000"
        }
    }
};
